import type { ActivityComponentType } from '@stackflow/react';
import ChannelInfoPage from '@/features/messaging/pages/ChannelInfoPage';

type Params = { conversationId: string };

const ChannelInfoActivity: ActivityComponentType<Params> = ({ params }) => (
  <ChannelInfoPage conversationId={params.conversationId} />
);

export default ChannelInfoActivity;
